module.exports = __webpack_public_path__ + "static/media/photo220.6ab1ac71.jpg";